//	FILE CONTAINS CONSTANTS RELATED TO THE DOWNLOADING OF DAIRY COMP FILES

export const DAIRY_COMP_CODES = Object.freeze({
	NO_GROWTH: "N",
	STAPH_AUREUS: "R",
	STEP_AG: "A",
	STAPH_OTHER: "C",
	STREP_OTHER: "S",
	OTHER: "O",
	MYCO: "M"
})

/*
		Klebsiella spp. = K
		Pasteurella spp. = W
		Pseudomonas spp. = P
		Serratia spp. = I
*/
export const ColiformInfo = [
	{
		regex: /klebsiella/,
		code: "K"
	},
	{
		regex: /pasteurella/,
		code: "W"
	},
	{
		regex: /pseudomonas/,
		code: "P"
	},
	{
		regex: /serratia/,
		code: "I"
	}
]

/*
		Yeast spp. = Y
		?? Fungus spp. = . ??
		Prototheca spp. = H
		T. pyogenes = T
		C. bovis = B
*/
export const OtherInfo = [
	{
		regex: /yeast/,
		code: "Y"
	},
	{
		regex: /fungus/,
		code: "."
	},
	{
		regex: /prototheca/,
		code: "H"
	},
	{
		regex: /t\. pyogenes/,
		code: "T"
	},
	{
		regex: /c\. bovis/,
		code: "B"
	}
]